export default __webpack_public_path__ + "static/media/DOM-JULY2025.1f2d600c.png";